<template>
    <div class="flex mb-px draggable relative">
        <!-- Draggable handle. -->
        <div class="w-6 flex-shrink-0 py-1.5 -my-px border-t bg-white">
            <div class="w-5 h-5 flex items-center">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-300 cursor-move pl-1 handle"
                   v-if="!readonly"></i>
            </div>
        </div>
        <div class="w-8 -ml-px flex">
            <span class="flex-grow -my-px lm-0 border border-gray-200 p-1 text-gray-400 italic bg-white"
                  v-text="index+1"></span>
        </div>
        <!-- Description. -->
        <div class="flex flex-col flex-1 m-0 relative">
            <div class="flex flex-1 m-0 relative">
                <div :key="itemRenderKey"
                     class="flex flex-1 m-0 -ml-px -mt-px mr-px -mb-px border-l border-t border-b border-gray-200 shadow-none min-w-24 relative">
                    <purchase-order-item-material-search #default="{ close, open, query, setQuery }"
                                                         ref="materialSearch"
                                                         @selected:material="selectMaterial"
                                                         @selected:addMaterial="addMaterial"
                                                         :purchase-order="purchaseOrder"
                                                         :purchase-order-item="item"
                                                         :current="itemClone"
                                                         class="text-xs mx-0 m-0 p-0 border-none text-blue-600 flex w-full"
                                                         trigger-class="flex w-full"
                                                         menuClass="w-[28rem]"
                    >
                        <autoresizable-textarea :height="el => (el.scrollHeight ) + 'px'"
                                                ref="autoresizable-description">
                            <autoresizable-textarea :height="el => (el.scrollHeight ) + 'px'" v-if="!readonly">
                    <textarea
                        placeholder="Item description..."
                        v-model="itemClone.description"
                        class="text-sm text-gray-600 m-0 px-2 mt-0 pt-1 pb-1 placeholder:text-gray-400 shadow-none relative focus:border-blue-500 border-none focus:z-20 resize-none"
                        style="min-height:32px"
                        type="text"
                        ref="description"
                        @focus="setQuery(itemClone.description);open()"
                        @input="setQuery(itemClone.description);updateDescription()"
                        rows="1"
                    ></textarea>
                            </autoresizable-textarea>
                            <div v-else
                                 class="text-sm text-gray-600 px-2 bg-white m-0 flex-grow pt-1 pb-1 placeholder:text-gray-400 shadow-none relative focus:border-blue-500 border-none focus:z-20 resize-none whitespace-pre-wrap"
                                 v-html="highlight(itemClone.description)" ref="description"
                            >
                            </div>
                        </autoresizable-textarea>
                    </purchase-order-item-material-search>
                </div>
                <div class="w-20 -ml-px flex relative">
                    <page-cell
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Qty..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        ref="quantity"
                        v-model="itemClone.quantity"
                        @input="updateQuantity(false)"
                        @blur="updateQuantity(true)"
                    ></page-cell>
                    <ui-dropdown menu-class="p-3 w-[32em]"
                                 trigger-class="absolute right-0 top-0 w-5 h-7 z-20 cursor-pointer"
                                 container-class="absolute right-0 top-0 w-5 h-7 cursor-pointer"
                                 v-if="itemClone.resolves && itemClone.resolves.length"
                    >
                        <template #default="{ toggle, open, close}">
                            <div class="absolute right-0 top-0 w-5 h-7 cursor-pointer"
                                 @mouseover="open"
                                 @click="readonly?false:adjustRFMResolves()"
                                 @mouseout="close">
                                <span class="fa fa-star text-green-400 absolute right-1 top-1"
                                      style="font-size: 10px"></span>
                            </div>
                        </template>
                        <template #menu="{ close }">
                            <div class="w-full p-2 z-30 text-xs">
                                <div class="flex font-medium text-gray-400 mb-1">
                                    <div class="ml-2 flex-grow" v-if="purchaseOrder.status === 'Draft'">Will be resolved
                                        against (when sent)
                                    </div>
                                    <div class="ml-2 flex-grow" v-else>Has been resolved against</div>
                                    <div class="flex-shrink mr-2">Quantity</div>
                                </div>
                                <template v-for="rfm in resolvesAsTree(itemClone.resolves)">
                                    <div
                                        class="flex space-x-2 text-left w-full text-gray-500 pl-2 pr-0 py-0"
                                        :title="rfm.reference"
                                    >
                                        <div class="truncate w-full py-1" v-text="rfm.reference"></div>
                                    </div>
                                    <div
                                        class="flex space-x-2 text-left w-full text-gray-500 pl-4 pr-0 py-0 text-blue-600"
                                        :title="resolve.rfm.item.material"
                                        v-for="resolve in rfm.items"
                                    >
                                        <div class="truncate w-full py-1"
                                             v-text="resolve.rfm.item.material+' ('+resolve.rfm.item.unitOfMeasure+')'"></div>
                                        <div class="flex-shrink mr-2" v-text="resolve.quantity"></div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </ui-dropdown>
                </div>
                <div class="w-16 -ml-px flex">
                    <page-cell
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="UoM..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.unitOfMeasure"
                        @input="updateUom()"
                        @blur="updateUom()"
                    ></page-cell>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        :class="rateRounded?'text-gray-400':''"
                        placeholder="Rate..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.rate"
                        @input="updateRate(false)"
                        @blur="updateRate(true)"
                    ></page-cell>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Net..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.net"
                        @input="updateNet(false)"
                        @blur="updateNet(true)"
                    ></page-cell>
                </div>
                <div class="w-20 -ml-px flex">
                    <page-cell
                        v-if="discountAsPercentage"
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Discount..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.discountPercentage"
                        @input="updateDiscountPercent(false)"
                        @blur="updateDiscountPercent(true)"
                    ></page-cell>
                    <page-cell v-else
                               currency
                               class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                               placeholder="Discount..."
                               :read-only="readonly"
                               :useTextareaReadonly="true"
                               v-model="itemClone.discountValue"
                               @input="updateDiscountValue(false)"
                               @blur="updateDiscountValue(true)"
                    ></page-cell>
                </div>
                <div class="w-16 -ml-px flex relative">
                    <page-cell
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Vat %..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.vatPercentage"
                        @input="updateVatPercentage(false)"
                        @blur="updateVatPercentage(true)"
                    ></page-cell>
                    <div v-if="!readonly && first"
                         class="absolute inline-block text-gray-300 hover:text-blue-400 text-xs cursor-pointer right-1 top-2 text-xs hover:text-blue-500 z-20"
                         @click="setAllToThis">
                        <span class="fas fa-arrow-down text-xs"></span>
                    </div>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Vat..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.vatValue"
                        @input="updateVatValue(false)"
                        @blur="updateVatValue(true)"
                    ></page-cell>
                </div>
                <div class="w-24 -ml-px flex">
                    <page-cell
                        currency
                        class="text-sm -my-px ml-0 px-1 py-1.5 border border-gray-200"
                        placeholder="Total..."
                        :read-only="readonly"
                        :useTextareaReadonly="true"
                        v-model="itemClone.value"
                        @input="updateValue(false)"
                        @blur="updateValue(true)"
                    ></page-cell>
                </div>
            </div>
            <div class="flex flex-1 m-0 relative" v-if="this.showDeliveryOptions">
                <div class="flex">
                    <purchase-order-package-search #default="{ close, open, query, setQuery }"
                                                   ref="packageSearch"
                                                   @selected:existingPackageItem="setPackage"
                                                   :current="item.packageName"
                                                   class="text-xs mx-0 -mt-px p-0 border-none text-blue-600"
                                                   menuClass="w-96"
                    >
                        <div class="flex truncate my-1">
                            <div
                                class="border rounded-md text-xs px-1.5 py-0.5 bg-gray-50 text-blue-600 ml-1 my-1 truncate whitespace-nowrap"
                                :class="!readonly?'hover:underline cursor-pointer':''"
                                @click="openPackageSearch(open)">
                                <span class="fas mr-1" :class="item.packageReference?'fa-cube':'fa-warehouse'"></span>
                                <span
                                    v-text="item.packageName?item.packageName:'Not related to a package'"></span>
                            </div>
                        </div>
                    </purchase-order-package-search>
                    <div class="flex my-1">
                        <div class="border rounded-md text-xs px-1.5 py-0.5 bg-gray-50 text-gray-600 ml-1 my-1">
                            <purchase-order-address-select #default="{ close, open, query, setQuery }"
                                                           ref="addressSearch"
                                                           @selected:existingAddress="setAddress"
                                                           @updateAddresses="updateAddresses"
                                                           @addAddress="addAddress"
                                                           @toggleCollection="toggleCollection"
                                                           @clearAddress="clearAddress"
                                                           :current="item.deliveryOption"
                                                           :package-reference="item.packageReference"
                                                           :addresses="addresses"
                                                           class="inline-block text-xs mx-0 -mt-px p-0 border-none text-blue-600"
                                                           menuClass="w-[36em]"
                            >
                                <span class="fas mr-1" @click="openAddressSearch(open)"
                                      :class="!item.deliveryOption?'fa-question text-gray-400':(item.deliveryOption.isDelivery?'fa-truck text-blue-500':'fa-people-carry text-blue-500')">
                                </span>
                                <span class="" @click="openAddressSearch(open)"
                                      :class="((item.deliveryOption && item.deliveryOption.address)?'text-blue-500':'text-gray-400')+(!readonly?' hover:underline cursor-pointer':'')">
                                    <template v-if="item.deliveryOption && item.deliveryOption.address">
                                        <span class="pr-1"
                                              v-for="line in addressLines(item.deliveryOption)"
                                              v-text="line">
                                        </span>
                                    </template>
                                    <div v-else class="inline-block">No address set</div>
                                    <span class="pr-1"
                                          v-if="item.deliveryOption && item.deliveryOption.contactName">-</span>
                                    <span class="mx-0" v-if="item.deliveryOption && item.deliveryOption.contactName"
                                          v-text="item.deliveryOption.contactName + (item.deliveryOption.contactNumber?'(' + item.deliveryOption.contactNumber + ')':'')"></span>
                                </span>

                            </purchase-order-address-select>
                            <span class="pr-1" v-if="item.deliveryOption">-</span>
                            <div class="relative inline" v-if="item.deliveryOption"
                                 @click="openDatePicker">
                                <ui-date-picker v-model="date"
                                                ref="datepicker"
                                                :with-time="false"
                                                class="absolute top top-0 left-0 opacity-0 block max-h-4 max-w-0 overflow-hidden"
                                                field="absolute top top-0 left-0 opacity-0 block max-h-4 max-w-0 overflow-hidden"
                                                @input="updateDate"
                                ></ui-date-picker>
                                <span
                                    :class="((item.deliveryOption && item.deliveryOption.date)?'text-blue-500':'text-blue-500')+(!readonly?' hover:underline cursor-pointer':'')"
                                    v-text="(item.deliveryOption && item.deliveryOption.date)?moment(item.deliveryOption.date).format('MMMM Do, YYYY'):'ASAP'"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-6 flex-shrink-0 bg-white border-t -mt-px border-gray-200">
            <ui-dropdown menu-class="p-3 w-72" v-if="!readonly">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded mt-1.5">
                        <i class="fa fa-ellipsis-h fa-fw pl-1 pr-1"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <template v-if="!readonly">
                        <ui-dropdown-item icon="fas fa-check"
                                          @click="adjustRFMResolves">
                            Resolve against RFM(s)
                        </ui-dropdown-item>
                        <ui-dropdown-divider></ui-dropdown-divider>
                        <ui-dropdown-item icon="fas fa-trash" danger
                                          @click="purchaseOrder.items.splice(purchaseOrder.items.indexOf(item),1); update();close();">
                            Remove Item
                        </ui-dropdown-item>
                    </template>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

import draggable from 'vuedraggable'
import PageCell from "../../ui/PageCell.vue";
import UiSelectSearchable from "../../ui/UiSelectSearchable.vue";
import UiSelect from "../../ui/UiSelect.vue";
import PurchaseOrderPackageSearch from "./PurchaseOrderPackageSearch.vue";
import {resolveNumericText, toCurrency} from "../../../utils";
import * as math from 'mathjs';
import _ from "lodash";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import moment from "moment";
import PurchaseOrderAddressSelect from "./PurchaseOrderAddressSelect.vue";
import PurchaseOrderItemMaterialSearch from "./PurchaseOrderItemMaterialSearch.vue";
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";

export default {
    computed: {
        moment() {
            return moment
        }
    },
    components: {
        UiButtonNew,
        UiDropdownItem, UiDropdownDivider, UiDropdown,
        AutoresizableTextarea,
        PurchaseOrderItemMaterialSearch,
        PurchaseOrderAddressSelect,
        UiDatePicker,
        PurchaseOrderPackageSearch,
        UiSelect,
        UiSelectSearchable,
        PageCell, draggable,
    },
    props: {
        index: Number,
        first: {type: Boolean, default: false},
        item: Object,
        readonly: {type: Boolean, default: false},
        addresses: Array,
        purchaseOrder: {type: Object, default: null},
        highlight: Function,
        showDeliveryOptions: {type: Boolean, default: false},
        discountAsPercentage: {type: Boolean, default: true},
    },
    data() {
        return {
            date: null,
            itemClone: {},
            itemKey: 0,
            quantity: this.item.quantity ? this.item.quantity : '',
            packageName: this.item.packageName,
            rateRounded: (resolveNumericText(this.item.rate) !== ((resolveNumericText(this.item.net) / resolveNumericText(this.item.quantity)))),
            deliveryOptionDateKey: 0,
            itemRenderKey: 0,
        }
    },
    watch: {
        readonly: function () {
            this.$nextTick(() => {
                this.resize();
            })
        }
    },
    methods: {
        setAllToThis() {
            this.$emit('setAllVatTo', this.item.vatPercentage)
        },
        adjustRFMResolves() {
            this.$modals.open('PurchaseOrderResolvePOToRFMs', {
                purchaseOrder: this.purchaseOrder,
                purchaseOrderItem: this.item,
                handle: async (modal) => {
                    this.itemClone.resolves = modal.resolves;
                    Object.assign(this.item, this.itemClone)
                    this.update();
                    modal.close()
                },
            })
        },
        resolvesAsTree(resolves) {
            let tree = []
            if (resolves) {
                resolves.forEach((item) => {
                    let rfm = tree.find((i) => i.id === item.rfm.id);
                    if (!rfm) {
                        rfm = {id: item.rfm.id, reference: item.rfm.reference, items: []}
                        tree.push(rfm)
                    }
                    rfm.items.push(item);
                })
            }
            return tree;
        },
        resize() {
            this.$refs['autoresizable-description'].forceResize()
        },
        openPackageSearch(open) {
            if (!this.readonly) {
                open();
                this.$nextTick(() => {
                    this.$refs.packageSearch.focus()
                })
            }
        },
        openAddressSearch(open) {
            if (!this.readonly) {
                open();
            }
        },
        openDatePicker() {
            if (!this.readonly) {
                this.$refs.datepicker.flatpickr.open()
            }
        },
        addressLines(deliveryOption) {
            let data = deliveryOption.address.trim();
            data = data.replace(/\n/g, ", ").trim();
            data = data.replace(/, ,/g, '').split(', ');
            let option = data.splice(-1, 1)
            data = data.map(item => {
                return item.trim() + ',';
            })
            if (option.length > 0) {
                data.push(option[0]);
            }
            return data;
        },
        updateAddresses(items, addressData) {
            this.$emit("updateAddresses", items, addressData);
        },
        setAddress(op) {
            this.$emit("setAddress", this.item, op.addressData);
        },
        addAddress(op) {
            this.$emit("addAddress", this.item, op.addressData);
        },
        clearAddress() {
            this.$emit("clearAddress", this.item);
        },
        toggleCollection(p) {
            if (!this.item.deliveryOption) {
                this.item.deliveryOption = {
                    isDelivery: false,
                    address: null,
                    date: null
                };
            }
            this.item.deliveryOption.isDelivery = p
            Object.assign(this.itemClone, this.item)
            this.update();
        },
        updateDate() {
            if (!this.item.deliveryOption) {
                this.item.deliveryOption = {
                    isDelivery: false,
                    address: null,
                    date: null
                };
            }
            if (this.item.deliveryOption.date === this.date) {
                this.date = null
            }
            this.item.deliveryOption.date = this.date;
            Object.assign(this.itemClone, this.item)
            this.update()
        },
        updateQuantity(finished) {
            let v = resolveNumericText(this.itemClone.quantity, false);
            this.itemClone.net = toCurrency(resolveNumericText(this.itemClone.rate) * v);
            let net = resolveNumericText(this.itemClone.net, false)
            if (this.discountAsPercentage) {
                net = net - ((net / 100) * resolveNumericText(this.itemClone.discountPercentage, false))
            } else {
                net -= resolveNumericText(this.itemClone.discountValue, false)
                net = Math.max(net, 0)
            }
            this.itemClone.vatValue = toCurrency((net / 100) * resolveNumericText(this.itemClone.vatPercentage));
            this.itemClone.value = toCurrency(net + resolveNumericText(this.itemClone.vatValue, false));
            if (finished) {
                this.itemClone.quantity = resolveNumericText(this.itemClone.quantity, false);
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.quantity = resolveNumericText(this.itemClone.quantity, false);
                Object.assign(this.item, _.omit(this.itemClone, ['quantity']))
            }
            this.rateRounded = (resolveNumericText(this.itemClone.rate, true) !== ((resolveNumericText(this.itemClone.net, true) / resolveNumericText(this.itemClone.quantity, true))))
            this.updateDiscountCalc()
            this.update();
        },
        updateRate(finished) {
            let v = resolveNumericText(this.itemClone.rate, false);
            let q = resolveNumericText(this.itemClone.quantity, false);
            if (((q < 0) && (v > 0)) || ((q > 0) && (v < 0))) {
                v = 0 - v;
            }
            this.itemClone.net = toCurrency(resolveNumericText(this.itemClone.quantity) * v);
            let net = resolveNumericText(this.itemClone.net, false)
            if (this.discountAsPercentage) {
                net = net - ((net / 100) * resolveNumericText(this.itemClone.discountPercentage, false))
            } else {
                net -= resolveNumericText(this.itemClone.discountValue, false)
                net = Math.max(net, 0)
            }
            this.itemClone.vatValue = toCurrency((net / 100) * resolveNumericText(this.itemClone.vatPercentage));
            this.itemClone.value = toCurrency(net + resolveNumericText(this.itemClone.vatValue, false));
            if (finished) {
                this.itemClone.rate = toCurrency(resolveNumericText(this.itemClone.rate));
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.rate = toCurrency(resolveNumericText(this.itemClone.rate));
                Object.assign(this.item, _.omit(this.itemClone, ['rate']))
            }
            this.rateRounded = (resolveNumericText(this.itemClone.rate) !== ((resolveNumericText(this.itemClone.net) / resolveNumericText(this.itemClone.quantity))))
            this.updateDiscountCalc()
            this.update();
        },
        updateNet(finished) {
            let v = resolveNumericText(this.itemClone.net, false);
            let q = resolveNumericText(this.itemClone.quantity, false);
            if (((q < 0) && (v > 0)) || ((q > 0) && (v < 0))) {
                v = 0 - v;
            }
            this.itemClone.rate = toCurrency(q ? (v / q) : 0);
            let nv = v
            if (this.discountAsPercentage) {
                nv = v - ((v / 100) * resolveNumericText(this.itemClone.discountPercentage, true))
            } else {
                nv -= resolveNumericText(this.itemClone.discountValue, false)
                nv = Math.max(nv, 0)
            }
            this.itemClone.vatValue = toCurrency((nv / 100) * resolveNumericText(this.itemClone.vatPercentage));
            this.itemClone.value = toCurrency(nv + resolveNumericText(this.itemClone.vatValue, false));
            if (finished) {
                this.itemClone.net = toCurrency(v);
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.net = toCurrency(v);
                Object.assign(this.item, _.omit(this.itemClone, ['net']))
            }
            this.rateRounded = (resolveNumericText(this.itemClone.rate) !== ((resolveNumericText(this.itemClone.net) / resolveNumericText(this.itemClone.quantity))))
            this.updateDiscountCalc()
            this.update();
        },
        updateDiscountPercent(finished) {
            let v = Math.min(100, Math.max(0, math.round(resolveNumericText(this.itemClone.discountPercentage.trim('%')), 2)))
            this.itemClone.discountValue = toCurrency((resolveNumericText(this.itemClone.net, true) / 100) * v);
            this.itemClone.value = toCurrency(resolveNumericText(this.itemClone.net, false) - resolveNumericText(this.itemClone.discountValue, false) + resolveNumericText(this.itemClone.vatValue, false));
            this.updateVatCalc()
            if (finished) {
                this.itemClone.discountPercentage = (0 + v) + '%';
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.discountPercentage = (0 + v) + '%';
                Object.assign(this.item, _.omit(this.itemClone, ['discountPercentage']))
            }
            this.update();
        },
        updateDiscountValue(finished) {
            let n = resolveNumericText(this.itemClone.net, true)
            let v = Math.min(n, resolveNumericText(this.itemClone.discountValue, true));
            if (n) {
                this.itemClone.discountPercentage = math.round((100 / n) * v, 2) + '%';
            } else {
                this.itemClone.discountPercentage = '0%'
            }
            this.itemClone.value = toCurrency(Math.max(0, n - v + resolveNumericText(this.itemClone.vatValue, false)));
            this.updateVatCalc()
            if (finished) {
                this.itemClone.discountValue = toCurrency(v)
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.discountValue = toCurrency(v)
                Object.assign(this.item, _.omit(this.itemClone, ['discountValue']))
            }
            this.update();
        },
        updateDiscountCalc() {
            let net = resolveNumericText(this.item.net, false)
            this.item.discountValue = Math.max(this.item.discountValue, net);
            if (this.discountAsPercentage) {
                this.item.discountValue = toCurrency((net / 100) * resolveNumericText(this.item.discountPercentage, true))
                this.itemClone.discountValue = this.item.discountValue
            } else {
                if (net) {
                    this.item.discountPercentage = math.round((resolveNumericText(this.item.discountValue) / net) * 100, 2) + '%'
                } else {
                    this.item.discountPercentage = '0%'
                }
                this.itemClone.discountPercentage = this.item.discountPercentage
            }
        },
        updateVatCalc() {
            let v = math.round(resolveNumericText(this.itemClone.vatPercentage.trim('%')), 2)
            let net = resolveNumericText(this.itemClone.net, false)
            if (this.discountAsPercentage) {
                net = net - ((net / 100) * Math.min(100, Math.max(0, resolveNumericText(this.itemClone.discountPercentage, true))))
            } else {
                net -= resolveNumericText(this.itemClone.discountValue, false)
            }
            net = Math.max(net, 0)

            this.itemClone.vatValue = toCurrency((net / 100) * v);
            this.itemClone.value = toCurrency(net + resolveNumericText(this.itemClone.vatValue, false));
        },
        updateVatPercentage(finished) {
            let v = math.round(resolveNumericText(this.itemClone.vatPercentage.trim('%')), 2)
            this.updateVatCalc()
            if (finished) {
                this.itemClone.vatPercentage = (0 + v) + '%';
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.vatPercentage = (0 + v) + '%';
                Object.assign(this.item, _.omit(this.itemClone, ['vatPercentage']))
            }
            this.update();
        },
        updateVatValue(finished) {
            let v = resolveNumericText(this.itemClone.vatValue, false);
            let net = resolveNumericText(this.itemClone.net, false)
            if (this.discountAsPercentage) {
                net = net - ((net / 100) * resolveNumericText(this.itemClone.discountPercentage, false))
            } else {
                net -= resolveNumericText(this.itemClone.discountValue, false)
            }
            let n = net;
            let q = resolveNumericText(this.itemClone.quantity, false);
            if (((q < 0) && (v > 0)) || ((q > 0) && (v < 0))) {
                v = 0 - v;
            }
            let valp = math.round((n ? 100 / n : 0) * v, 2) + '%';
            let val = toCurrency(net + v);
            if (val !== this.itemClone.value) {
                this.itemClone.vatPercentage = valp;
                this.itemClone.value = val;
            }

            if (finished) {
                this.itemClone.vatValue = toCurrency(v);
                Object.assign(this.item, this.itemClone)
            } else {
                this.item.vatValue = toCurrency(v);
                Object.assign(this.item, _.omit(this.itemClone, ['vatValue']))
            }
            this.update();
        },
        updateUom() {
            Object.assign(this.item, this.itemClone)
            this.update();
        },
        updateValue(finished) {
            let v = resolveNumericText(this.itemClone.value, false);
            let q = resolveNumericText(this.itemClone.quantity, false);
            if (((q < 0) && (v > 0)) || ((q > 0) && (v < 0))) {
                v = 0 - v;
            }

            let pre = (v / (1 + (resolveNumericText(this.itemClone.vatPercentage) / 100)));
            if (this.discountAsPercentage) {
                pre = pre / (1 - (resolveNumericText(this.itemClone.discountPercentage, false) / 100))
            } else {
                pre += resolveNumericText(this.itemClone.discountValue, false)
            }
            this.itemClone.net = toCurrency(pre);
            let n = resolveNumericText(this.itemClone.net, false);
            this.itemClone.rate = toCurrency(q ? (n / q) : 0);
            if (this.discountAsPercentage) {
                n = n - ((n / 100) * resolveNumericText(this.itemClone.discountPercentage, false))
            } else {
                n -= resolveNumericText(this.itemClone.discountValue, false)
            }

            this.itemClone.vatValue = toCurrency((n / 100) * resolveNumericText(this.itemClone.vatPercentage));
            if (finished) {
                this.itemClone.value = toCurrency(v);
                Object.assign(this.item, this.itemClone)
            } else {
                Object.assign(this.item, _.omit(this.itemClone, ['value']))
                this.item.value = toCurrency(v);
            }
            this.rateRounded = (resolveNumericText(this.itemClone.rate) !== ((resolveNumericText(this.itemClone.net) / resolveNumericText(this.itemClone.quantity))))
            this.updateDiscountCalc()
            this.update();
        },
        updateDescription() {
            Object.assign(this.item, this.itemClone)
            this.update();
        },
        update() {
            this.$emit('updated');
        },
        setPackage(op) {
            let update = async () => {
                this.itemClone.packageReference = op.packageItem ? op.packageItem.referenceNumber : null;
                this.itemClone.packageName = op.packageItem ? op.packageItem.name : null;
                this.item.packageReference = op.packageItem ? op.packageItem.referenceNumber : null;
                this.item.packageName = op.packageItem ? op.packageItem.name : null;
                this.update();
            }
            if (this.itemClone.resolves.length) {
                this.$modals.confirm({
                    title: `Do you want to update the Package?`,
                    button: 'Yes, update the Package',
                    paragraphs: ['This will clear the proposed RFM resolves on this item, as they will no longer be valid when changing the package.'],
                    handle: async () => {
                        this.item.resolves = []
                        this.itemClone.resolves = []
                        update()
                        this.itemRenderKey++;
                    }
                })
            } else {
                update();
            }
        },
        selectMaterial(rfm, material) {
            this.itemClone.description = material.material;
            this.itemClone.unitOfMeasure = material.unitOfMeasure;
            this.itemClone.quantity = material.required;
            this.toggleResolve(rfm, material);
            if (this.itemClone.resolves.length > 1) {
                this.itemClone.resolves = [];
                this.toggleResolve(rfm, material);
            }
            Object.assign(this.item, this.itemClone)
            this.update();
            this.itemRenderKey++;
            // Give time to close down dropdown
            setTimeout(() => {
                this.$refs.quantity.focusAsNew()
            }, 50)
        },
        addMaterial(rfm, material) {
            this.itemClone.description = material.material;
            this.itemClone.unitOfMeasure = material.unitOfMeasure;
            this.toggleResolve(rfm, material);
            this.itemClone.quantity = this.itemClone.resolves.reduce((a, c) => a + c.quantity, 0)
            Object.assign(this.item, this.itemClone)
            this.update();
        },
        toggleResolve(rfm, material) {
            let index = this.itemClone.resolves.findIndex((i) => (i.rfm.id === rfm.id) && (i.rfm.item.id === material.id));
            if (index > -1) {
                this.itemClone.resolves.splice(index, 1);
            } else {
                this.itemClone.resolves.push({
                    rfm: {
                        id: rfm.id,
                        reference: rfm.reference,
                        packageReference: rfm.packageReference,
                        item: {
                            id: material.id,
                            material: material.material,
                            unitOfMeasure: material.unitOfMeasure,
                            required: material.required
                        },
                    },
                    quantity: material.required
                });
            }
        },
        resetPackage() {
            if (!this.packageName) {
                this.itemClone.packageReference = null
                this.itemClone.packageName = null
                this.item.packageReference = null
                this.item.packageName = null
            }
            this.packageName = this.itemClone.packageName
            this.update();
        },
    },
    mounted() {
        this.itemClone = structuredClone(this.item)
        this.itemClone.rate = toCurrency(resolveNumericText(this.itemClone.rate, false));
        this.itemClone.net = toCurrency(resolveNumericText(this.itemClone.net, false));
        this.itemClone.vatValue = toCurrency(resolveNumericText(this.itemClone.vatValue, false));
        this.itemClone.value = toCurrency(resolveNumericText(this.itemClone.value, false));
        this.rateRounded = (resolveNumericText(this.itemClone.rate) !== ((resolveNumericText(this.itemClone.net) / resolveNumericText(this.itemClone.quantity))))
        this.$nextTick(() => {
            this.resize()
        })
    }
}
</script>